import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShopType } from 'models';

const initialState = {
  shopInfo: {} as ShopType,
};

const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    getShopInfo(state, action: PayloadAction<{ shop_id: number; appName: string }>) {},
    getShopInfoSuccess(state, action: PayloadAction<any>) {
      state.shopInfo = action.payload;
    },
  },
});

// Actions
export const shopAction = shopSlice.actions;

// Reducer
const shopReducer = shopSlice.reducer;
export default shopReducer;
